export const onboardingContent = {
  title: '要件定義の使い方',
  sections: [
    {
      heading: '概念モデル',
      image: '/images/help/requirements_specifications/SS1.png',
      body: '業務に登場するモノ・出来事を一覧化したものです。RESOURCE（得意先・商品など）とEVENT（受注・発注など）に分かれます。'
    },
    {
      heading: '要求',
      image: '/images/help/requirements_specifications/SS2.png',
      body: 'なぜその機能が必要かという背景（要求）の一覧です。内容を確認したらチェックを入れてください。'
    },
    {
      heading: '要件',
      image: '/images/help/requirements_specifications/SS3.png',
      body: '要求を実現するための具体的な仕様（要件）です。種別や紐づく要求も確認できます。'
    },
    {
      heading: '業務フロー（ステップリスト）',
      image: '/images/help/requirements_specifications/SS4.png',
      body: '担当者ごとの業務ステップの一連の流れを一覧表示します。'
    },
    {
      heading: '業務フロー（フロー表示）',
      image: '/images/help/requirements_specifications/SS5.png',
      body: '同じ流れを、担当者を横軸にした図で確認できます。「フロー表示」ボタンで切り替えられます。'
    },
    {
      heading: '権限マトリクス',
      image: '/images/help/requirements_specifications/SS6.png',
      body: '誰が何を作成・参照・更新・削除できるかを一覧化したものです。要確認の項目は色付きで表示されます。'
    },
    {
      heading: '確認ポイント',
      image: '/images/help/requirements_specifications/SS7.png',
      body: '要件定義で確認しておきたい論点を、モデル検証・用語ズレ・例外経路・整合性・権限などのカテゴリ別に一覧表示します。内容に問題なければ「品質チェックを依頼する」から確定に進みます。'
    }
  ]
}
